import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AppLayoutKitchen from '../../layout/AppLayoutKitchen';
import defaultContent from './default';

const ContentComponent = ({ match }) => (
    <AppLayoutKitchen>
        <Switch>
            <Redirect
                exact
                from={`${match.url}/`}
                to={`${match.url}/default`}
            />
            <Route path={`${match.url}/default`} component={defaultContent} />
            <Route path={`${match.url}`} component={defaultContent} />
            <Redirect to='/error' />
        </Switch>
    </AppLayoutKitchen>
);
export default ContentComponent;
